import { authUrl, accountUrl, cookieSettings } from './config';
import jwt_decode from 'jwt-decode';
import { Cookies } from 'react-cookie';
import { handleAppTokenResponse } from './response.service';

export var refreshLock = false;

const cookies = new Cookies();

const getAppToken = async (orgId) => {

    if (!refreshLock) {

        refreshLock = true;

        console.log("Getting app token...");

        let organisationId = orgId || await findAOCookie();
        
        if (organisationId) {
            return new Promise((resolve, reject) => {

                let requestOptions = {
                    method: 'POST',
                    credentials: 'include',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ type: "Portal", organisationId: organisationId })
                };

                return fetch(`${authUrl}/sso/token`, requestOptions)
                    .then(handleAppTokenResponse)
                    .then(result => {
                        delete result.success;
                        delete result.message;
                        let tokenParts = jwt_decode(result.token);
                        tokenParts.token = result.token;
                        localStorage.setItem('FingotiPortal', JSON.stringify(tokenParts));
                        cookies.set("ActiveOrganisation", organisationId, cookieSettings());
                        refreshLock = false;
                        return resolve(tokenParts)
                    })
                    .catch(error => {
                        refreshLock = false;
                        if(error.requireAuth) {
                            window.location.assign(`${accountUrl}?ReturnUrl=${window.location}`);
                        } else {
                            return reject(error);
                        }
                    })
            })
        } else {
            return Promise.reject({ requireAuth: true, error: "Failed to get app token"});
        }
    } else {
        return Promise.reject("Refresh locked");
    }
}

const findAppToken = () => {
    console.log("Finding App token...");
    return new Promise((resolve, reject) => {
        const appToken = JSON.parse(localStorage.getItem('FingotiPortal'));

        if (appToken) {
            return resolve(appToken);
        } else {
            return reject(null);
        }
    });
}

const findAOCookie = () => {
    return new Promise((resolve) => {
        let cookie = cookies.get("ActiveOrganisation");
        if (cookie) {
            return resolve(cookie);
        } else {
            findAppToken()
                .then(appToken => {
                    return resolve(appToken.oid);
                })
                .catch(() => {
                    return resolve(false);
                })
        }
    })
}

const appLogout = () => {
    localStorage.removeItem('FingotiPortal')
}

const authToken = () => {
    const user = JSON.parse(localStorage.getItem('FingotiPortal'));

    if (user && user.token) {
        return user.token;
    } else {
        return undefined;
    }
}

const authHeader = () => {
    const user = JSON.parse(localStorage.getItem('FingotiPortal'));

    if (user && user.token) {
        return { Authorization: `Bearer ${user.token}` };
    } else {
        return { Authorization: `` };
    }
}


export const authService = {
    getAppToken,
    findAppToken,
    findAOCookie,
    authToken,
    authHeader,
    appLogout
}